import React from 'react';
import { motion } from 'framer-motion';
import { triggerChat } from '@/utils/chatTrigger';

const Hero = () => {
  return (
    <section className="relative pt-20 pb-32 overflow-hidden">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-gold/10 rounded-full blur-[120px] pointer-events-none" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}>
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-white/5 border border-white/10 mb-6 text-gold">
              <span className="w-2 h-2 rounded-full bg-red-500 animate-pulse"></span>
              <span className="text-xs font-bold tracking-widest text-gray-300 uppercase">AgentOnDemand Live</span>
            </div>
            <h1 className="text-5xl lg:text-7xl font-anton tracking-wide leading-[1.1] mb-6 text-white uppercase">
              Stop Losing Leads To Forms. <span className="text-gold">Start Booking Appointments On Autopilot.</span>
            </h1>
            <p className="text-lg lg:text-xl text-gray-400 mb-10 leading-relaxed font-manrope font-medium max-w-2xl">
              AgentOnDemand puts a live agent on standby the second a visitor lands on your site — so instead of a form nobody fills out or a chatbot nobody trusts, you get booked appointments and captured leads, automatically.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 mb-8">
              <button 
                onClick={triggerChat}
                className="inline-flex justify-center items-center px-8 py-4 rounded-md bg-gold text-navy font-bold text-lg tracking-wide uppercase transition-all hover:bg-gold-hover hover:-translate-y-1 hover:shadow-[0_10px_30px_rgba(245,166,35,0.3)] active:scale-95"
              >
                See It In Action
              </button>
              <a href="#pricing" className="inline-flex justify-center items-center px-8 py-4 rounded-md bg-white/5 text-white font-bold text-lg tracking-wide uppercase border border-white/10 transition-all hover:bg-white/10">
                View Pricing
              </a>
            </div>
          </motion.div>

          <motion.div initial={{ opacity: 0, scale: 0.95 }} animate={{ opacity: 1, scale: 1 }} transition={{ duration: 0.6, delay: 0.2 }} className="relative w-full aspect-[4/3] rounded-2xl overflow-hidden border border-white/10 shadow-2xl bg-navy-light group">
            <div className="absolute inset-0 bg-navy">
              <img 
                src="https://firebasestorage.googleapis.com/v0/b/phonesites-prod.appspot.com/o/images%2F6rHBijo2pUQV1ZlpCwFjbdqdjG53%2F1772040721791*Custom%20recording%202026-02-25%2011-25-34*gif?alt=media&token=a05f90a5-19d0-4746-9a07-32ae43b4534a" 
                alt="AgentOnDemand Live Interface" 
                className="w-full h-full object-cover opacity-90 transition-transform duration-700 group-hover:scale-105" 
              />
              <div className="absolute inset-0 bg-gradient-to-t from-navy/60 to-transparent"></div>
            </div>
            <div className="absolute bottom-0 inset-x-0 p-6 z-10 flex justify-between items-end">
              <div>
                <h3 className="text-white font-bold text-lg">Live Demo</h3>
                <p className="text-gray-300 text-sm">Automated conversion in real-time</p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Hero;